/* SIZESOFTX
=========================================================================================
* Descripción: Acceso a Grafana embebido
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 11/09/2026 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import React from "react";
import { Alert, Box, Typography } from "@mui/material";
import { grafanaUrl } from "../settings/ApiConfig";

const GrafanaPage = () => {
  if (!grafanaUrl) {
    return <Alert severity="info">Configure REACT_APP_GrafanaUrl en .env-cmdrc.json.</Alert>;
  }

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Grafana
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Requiere GF_SECURITY_ALLOW_EMBEDDING=true y autenticación previa con un usuario viewer en
        Grafana.
      </Typography>
      <Box
        component="iframe"
        src={grafanaUrl}
        title="Grafana SizeSoftX"
        sx={{ width: "100%", height: "calc(100vh - 150px)", border: 0 }}
        sandbox="allow-scripts allow-same-origin allow-forms"
      />
    </Box>
  );
};

export default GrafanaPage;